module.exports = __webpack_public_path__ + "static/media/korea-cover.45a8a54c.jpg";